import { withStyles } from '@material-ui/core/styles';

export default withStyles(() => ({
  filter: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  buttonFilter: {
    display: 'flex',
    alignItems: 'center',
    '&.--active': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
    '& span.material-icons': {
      position: 'relative',
      top: 1,
      marginRight: '0.5rem',
      fontSize: 15,
    },
  },
  badge: {
    right: '-28px',
    backgroundColor: '#009358',
  },
  containerFilter: {
    width: '100%',
    background: '#E8E8E8',
    borderRadius: 4,
    marginTop: 4,
    display: 'none',
    transition: '0.3s',
    '&.--active': {
      display: 'block',
    },
  },
  containerContent: {
    padding: 16,
  },
  labelPeriod: {
    width: '100%',
    display: 'block',
    fontSize: 15,
    marginBottom: 8,
  },
  controlDatePicker: {
    '& > .DateRangePicker': {
      '& div:not(.DateInput):not(.DayPickerNavigation_button):first-child': {
        width: '100%',
      },
      '& .DateRangePickerInput__withBorder': {
        border: '1px solid #ced4da',
      },
      '& .DateInput__small': {
        width: 'calc(50% - 10px)',
        '& input': {
          lineHeight: '22px',
          textAlign: 'center',
          fontWeight: 400,
        },
      },
      '& .DateRangePickerInput_arrow': {
        width: 20,
        justifyContent: 'center',
        fontSize: 25,
      },
    },
  },
  // questions list
  questions: {
    marginBottom: 12,
  },
  questionsContainer: {
    borderRadius: '5px !important',
  },
  questionsTitle: {
    fontSize: 16,
    fontWeight: 400,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  questionsText: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    '& span': {
      display: 'block',
      marginTop: 4,
      fontSize: 13,
      color: '#999',
    },
  },
  doneIcon: {
    color: '#009358',
  },
  questionsContent: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  // chat
  questionsWrapper: {
    width: '100%',
    display: 'block',
  },
  questionChat: {
    background: '#f9f9f9',
    borderRadius: 5,
    width: '100%',
    display: 'block',
  },
  questionChatBody: {
    width: '100%',
    maxHeight: 400,
    height: 'auto',
    overflow: 'auto',
    padding: 20,
    position: 'relative',
  },
  questionsChatMessage: {
    width: 'auto',
    maxWidth: '550px',
    borderRadius: 4,
    marginBottom: 12,
    clear: 'both',
    fontSize: 15,
    lineHeight: '23px',
    fontWeight: 400,
    color: '#fff',
    '&.--producer': {
      float: 'right',
    },
    '&:last-child': {
      marginBottom: 0,
    },
  },
  questionChatName: {
    display: 'block',
    fontSize: 16,
    color: '#333',
    marginBottom: 16,
    width: '100%',
    fontWeight: 400,
    textAlign: 'left',
    '& span': {
      fontSize: 14,
      color: '#92959E',
      marginLeft: 5,
    },
    '&.--producer': {
      textAlign: 'right',
      '& span': {
        marginLeft: 0,
        marginRight: 5,
      },
    },
  },
  questionChatContent: {
    width: 'auto',
    maxWidth: '100%',
    padding: '8px 16px',
    background: '#94C2ED',
    display: 'inline-block',
    borderRadius: 5,
    fontWeight: 400,
    position: 'relative',
    '&:after': {
      content: '" "',
      width: 0,
      height: 0,
      borderLeft: '12px solid transparent',
      borderRight: '12px solid transparent',
      borderBottom: '12px solid #94C2ED',
      position: 'absolute',
      top: -10,
      left: 8,
    },
    '&.--producer': {
      background: '#86BB71',
      float: 'right',
      marginBottom: 8,
      '&:after': {
        borderBottom: '12px solid #86BB71',
        right: 8,
        left: 'auto',
      },
    },
  },
  questionsChatIcons: {
    width: '100%',
    display: 'block',
    marginTop: 8,
    color: '#888',
    clear: 'both',
    '& span': {
      fontSize: 18,
      cursor: 'pointer',
      marginRight: 4,
    },
    '&.--producer': {
      textAlign: 'right',
      '& span': {
        marginRight: 0,
        marginLeft: 4,
      },
    },
  },
  questionChatResponse: {
    width: '100%',
    display: 'block',
  },
  questionsTextarea: {
    width: '100%',
    minHeight: '100px',
    borderRadius: '4px',
    resize: 'none',
    border: '1px solid #ced4da',
    padding: '10px 12px',
    fontSize: 15,
    lineHeight: '19px',
    fontWeight: 400,
    color: '#596375',
    transition: '0.3s',
    '&:focus': {
      borderColor: '#a7a7a7',
    },
  },
  questionChatButton: {
    width: '100%',
    textAlign: 'right',
  },
}));
